import { forwardRef, useContext, useMemo } from 'react';
import propTypes from 'prop-types';
import { ThemeContext } from 'styled-components';

import { handleNormalizeString } from '@kiper/fns';
import {
  createSemanticSelectStyles,
  mergeSelectStyles,
} from '../Select/selectStyles';
import AsyncSelectStyled from './styles';

const AsyncSelect = forwardRef(
  (
    {
      onChange,
      value,
      delay,
      name: _name,
      options,
      styles: customStyles,
      ...props
    },
    ref,
  ) => {
    const { colors } = useContext(ThemeContext);
    const handleFilterOptions = inputValue => {
      return options?.filter(option => {
        const normalizedInputValue = handleNormalizeString(inputValue);

        const normalizedOptionLabel = handleNormalizeString(
          option?.label || option?.name,
        );

        return normalizedOptionLabel?.includes(normalizedInputValue);
      });
    };

    const semanticSelectStyles = useMemo(
      () => createSemanticSelectStyles(colors),
      [colors],
    );

    const mergedStyles = useMemo(
      () => mergeSelectStyles(semanticSelectStyles, customStyles),
      [semanticSelectStyles, customStyles],
    );

    const handleLoadOptions = (inputValue, callback) => {
      setTimeout(() => {
        callback(handleFilterOptions(inputValue));
      }, delay);
    };

    return (
      <AsyncSelectStyled
        {...props}
        ref={ref}
        loadOptions={handleLoadOptions}
        onChange={onChange}
        value={value}
        openMenuOnClick={false}
        styles={mergedStyles}
        cacheOptions
      />
    );
  },
);
export default AsyncSelect;

AsyncSelect.displayName = 'AsyncSelect';

AsyncSelect.propTypes = {
  value: propTypes.oneOfType([
    propTypes.any,
    propTypes.object,
    propTypes.array,
  ]),
  delay: propTypes.number,
  onChange: propTypes.func.isRequired,
  options: propTypes.array.isRequired,
  name: propTypes.string.isRequired,
  styles: propTypes.object,
};

AsyncSelect.defaultProps = {
  value: '',
  delay: 0,
  styles: undefined,
};
